"use client";

import BackgroundImage from "../../components/background-image";
import Container from "@/components/Container";
import { PrismicNextImage } from "@prismicio/next";
import StyledButton from "@/components/StyledButton";
import PlayVideo from "../../components/play-video";
import TilesBlock from "../../components/tiles-block";
import VideoModal from "../../components/video-modal";
import { useState } from "react";
import { PrismicRichText } from "@prismicio/react";
import Image from "next/image";
import Investing from "@/app/assets/InvestingLogo.png";
import Link from "next/link";

const getFeaturedText = (lang = "en-us") => {
  if (lang === "es-es") return "Presentado en";
  if (lang === "ru-ru") return "Представлено на";
  return "Featured on";
};

export default function HomeHero({ slice, lang, ...others }) {
  const [show, setShow] = useState(false);

  function onClickPlayHandler() {
    setShow(true);
  }

  return (
    <>
      <div className="relative h-full">
        <BackgroundImage
          className="hidden lg:block"
          imageClassName="object-top"
          slice={slice}
        />

        <Container className="lg:border-b lg:border-b-[rgba(255,255,255,0.3)] relative z-10 pb-[40px] md:py-[80px] lg:pb-[120px] pt-[200px] md:pt-[200px] lg:pt-[235px] ">
          <BackgroundImage
            className="block lg:hidden"
            imageClassName="!object-[68%_top]"
            slice={slice}
          />
          <div className="relative z-10 ">
            <div className="lg:flex lg:flex-nowrap lg:gap-[16px] lg:items-start">
              <div className="hidden lg:block w-full max-w-[64px] pt-[12px] border-b-[2px] border-b-[#C4C4C8]"></div>

              <div>
                <div className="mb-[4px] md:mb-[8px] lg:mb-[32px] title-font max-w-[189px] md:max-w-none title-small text-[white]">
                  <PrismicRichText field={slice?.sub_title} />
                </div>
                <div className="lg:hidden w-full max-w-[64px] md:max-w-[89px] pt-[12px] border-b-[2px] border-b-[#C4C4C8] mb-[22px] md:mb-[32px]"></div>
                <div className="mb-[22px] md:mb-[32px] title-font title-3xl lg:max-w-[643px] md:max-w-[565px] text-[white]">
                  <PrismicRichText field={slice?.title} />
                </div>
                <div className="mb-[14px] md:mb-[20px] lg:mb-[24px] text-medium lg:max-w-[643px] md:max-w-[565px] text-[white]">
                  <PrismicRichText field={slice?.description} />
                </div>
                {slice.signature_image?.url && (
                  <PrismicNextImage
                    className="mb-[12px] md:mb-[8px] lg:mb-[32px] h-[62px] w-[218px] md:h-[76px] md:w-[276px] lg:h-[70px] lg:w-[251px] object-cover"
                    field={slice.signature_image}
                    fallbackAlt=""
                    priority
                    loading="eager"
                  />
                )}

                <div className="flex items-center  gap-[34px] md:gap-[64px]">
                  {slice.buttons.map((item, idx) => {
                    return (
                      <StyledButton
                        key={idx}
                        link={item?.link}
                        label={item?.label}
                        icon={item?.icon}
                        iconPosition={item?.icon_position}
                        variant={item?.variant}
                      />
                    );
                  })}

                  <div className="relative z-[100] lg:hidden">
                    <PlayVideo slice={slice} onClickPlay={onClickPlayHandler} />
                  </div>
                </div>
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    "https://www.investing.com/news/press-releases/brooklyn-car-accident-survival-guide--what-to-do-in-the-first-24-hours-4181615"
                  }
                  className="inline-block lg:mt-[32px] max-w-[128px] md:max-w-[160px]"
                >
                  <div className="text-base mb-1 text-[white]">
                    {getFeaturedText(lang)}
                  </div>
                  <Image
                    src={Investing}
                    alt="Investing.com"
                    className="max-w-[128px] md:max-w-[160px]"
                  />
                </Link>
              </div>
            </div>
            <div className="absolute z-[100] right-0 bottom-0 hidden lg:block">
              <PlayVideo slice={slice} onClickPlay={onClickPlayHandler} />
            </div>
          </div>
        </Container>

        <TilesBlock className="flex lg:hidden" slice={slice} />

        <div className="hidden lg:block ">
          <Container className="">
            <TilesBlock slice={slice} />
          </Container>
        </div>
      </div>
      <VideoModal
        link={slice?.video_url}
        video={slice?.video}
        show={show}
        onHide={() => setShow(false)}
      />
    </>
  );
}
